/* eslint-disable import/no-cycle */
import {ArtistCollectioneItem} from './artist-collection-item';

export {ArtistCollectioneItem};
